export default {
    title: 'Maßnahmen',
    freetext: 'Freitext',
    serial_number: 'Maßnahmennummer',
    year: 'Jahr',
    status: 'Status',
    id: 'ID',
    event: 'Maßnahme',
    organisation: 'Organisation',
    fundingProgram: 'Förderprogramm',
    funding_program: 'Förderprogramm',
    period: 'Von - Bis',
    formProcesses: 'Formulare',
    subsidy_amount: 'Zuschusshöhe',
    intended_use: 'Verwendungszweck',
    sum: 'Gesamtbetrag',
    amount: 'Betrag',
    process: 'Maßnahme',

    qf_ownOnly: 'Nur eigene Maßnahmen'
}